import { FC } from 'react';
import {
  Box,
  IconButton,
  SystemStyleObject,
  useStyleConfig,
} from '@chakra-ui/react';
import { ReactComponent as Close24 } from 'resources/images/close-big.svg';
import { AppOverlayPortal } from 'app/components/AppOverlayPortal';
import { useAppSelector } from 'app/store';
import { getPlayerHeight } from 'app/store/AudioPlayer/selectors';

interface OverlayDialogProps {
  className?: string;
  onClose?: () => void;
  children?: React.ReactNode;
  sx?: SystemStyleObject;
}

export const OverlayDialog: FC<OverlayDialogProps> = ({
  children,
  className,
  onClose,
  sx,
}) => {
  const playerHeight = useAppSelector(getPlayerHeight);
  const styles = useStyleConfig('OverlayDialog', {});

  return (
    <AppOverlayPortal>
      <Box
        __css={styles}
        h={`calc(100% - ${playerHeight}px)`}
        sx={sx}
        className={className}
      >
        {onClose && (
          <IconButton
            aria-label="close-overlay"
            className="close-button"
            data-testid="close-overlay-button"
            onClick={onClose}
          >
            <Close24 color="inherit" />
          </IconButton>
        )}
        {/* Fix for firefox issue with overlay backgroud (https://sessionid.atlassian.net/browse/SS-6938) */}
        <Box position="fixed" right={0} outline="1px solid transparent" />
        {children}
      </Box>
    </AppOverlayPortal>
  );
};
